import { createRoutine } from 'redux-saga-routines';
import { ACTION_TOGGLE_SIDEBAR } from '@/constants';

export default createRoutine(ACTION_TOGGLE_SIDEBAR);
